export const teamsPosition = [
    { label: "5-4-1", value: 541 },
    { label: "5-3-2", value: 532 },
    { label: "4-5-1", value: 451 },
    { label: "4-4-2", value: 442 },
    { label: "4-3-3", value: 433 },
    { label: "3-5-2", value: 352 },
    { label: "3-4-3", value: 343 },
    { label: "5-2-2-1", value: 5221 },
    { label: "5-3-1-1", value: 5311 },
    { label: "5-1-3-1", value: 5131 },
    { label: "5-2-1-2", value: 5212 },
    { label: "5-1-2-2", value: 5122 },
    { label: "4-3-2-1", value: 4321 },
    { label: "4-2-3-1", value: 4231 },
    { label: "4-4-1-1", value: 4411 },
    { label: "4-1-4-1", value: 4141 },
    { label: "4-2-2-2", value: 4222 },
    { label: "4-3-1-2", value: 4312 },
    { label: "4-1-3-2", value: 4132 },
    { label: "4-2-1-3", value: 4213 },
    { label: "4-1-2-3", value: 4123 },
    { label: "3-2-3-2", value: 3232 },
    { label: "3-3-2-2", value: 3322 },
    { label: "3-1-4-2", value: 3142 },
    { label: "3-4-1-2", value: 3412 },
    { label: "3-2-2-3", value: 3223 },
    { label: "3-1-3-3", value: 3133 },
    { label: "3-3-1-3", value: 3313 },
];

export const optaPositions = [
    { "label": "442", "value": 442},
    { "label": "41212", "value": 41212},
    { "label": "433", "value": 433},
    { "label": "451", "value": 451},
    { "label": "4411", "value": 4411},
    { "label": "4141", "value": 4141},
    { "label": "4231", "value": 4231},
    { "label": "4321", "value": 4321},
    { "label": "532", "value": 532},
    { "label": "541", "value": 541},
    { "label": "352", "value": 352},
    { "label": "343", "value": 343},
    { "label": "4222", "value": 4222},
    { "label": "3511", "value": 3511},
    { "label": "3421", "value": 3421},
    { "label": "3412", "value": 3412},
    { "label": "3142", "value": 3142},
    { "label": "343d", "value": "343d"},
    { "label": "4132", "value": 4132},
    { "label": "4240", "value": 4240},
    { "label": "4312", "value": 4312},
    { "label": "3241", "value": 3241},
    { "label": "3331", "value": 3331}
];



// WEBPACK FOOTER //
// ./src/helpers/teamsPosition.js